import { FC, ReactElement, useMemo } from 'react';

import { formatTimeRange } from './utils';

export interface ITimeRangeProps {
	fromDate: string | Date;
	toDate: string | Date;
	render?: (timeRangeStr: string) => ReactElement;
}

const defaultRender = (timeRangeStr: string): ReactElement => (
	// eslint-disable-next-line react/jsx-no-useless-fragment -- ReactElement return needs an element
	<>{timeRangeStr}</>
);

export const TimeRange: FC<ITimeRangeProps> = ({
	fromDate,
	toDate,
	render = defaultRender,
}) => {
	const timeRangeStr = useMemo(
		() => formatTimeRange(fromDate, toDate),
		[fromDate, toDate]
	);

	return render(timeRangeStr);
};
